module.exports = __webpack_public_path__ + "img/come-vict-08.b642a7fc.jpg";